import { notifications } from "@mantine/notifications";

const nativeSettingsModule =
	import.meta.env.VITE_CAPACITOR_BUILD === "true"
		? import("capacitor-native-settings")
		: null;

export async function openAppSettings() {
	if (!nativeSettingsModule) {
		notifications.show({
			title: "Cannot open settings",
			message:
				"Opening app settings is only supported in the mobile app. Please adjust location permissions in your browser or device settings.",
			color: "yellow",
		});
		return;
	}

	try {
		const { NativeSettings, AndroidSettings, IOSSettings } =
			await nativeSettingsModule;
		const result = await NativeSettings.open({
			optionAndroid: AndroidSettings.ApplicationDetails,
			optionIOS: IOSSettings.App,
		});

		if (!result.status) {
			notifications.show({
				title: "Could not open settings",
				message: "Unknown error",
				color: "red",
			});
		}
	} catch (err) {
		notifications.show({
			title: "Could not open settings",
			message: err instanceof Error ? err.message : "Unknown error",
			color: "red",
		});
	}
}
